/*************************************************************************
 *
 * COMPRO CONFIDENTIAL
 * __________________
 *
 *  [2015] - [2020] Compro Technologies Private Limited
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Compro Technologies Private Limited. The
 * intellectual and technical concepts contained herein are
 * proprietary to Compro Technologies Private Limited and may
 * be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Compro Technologies Pvt. Ltd..
 ***************************************************************************/

/***********************************************************
 * comproDLS SDK AUTH API Adaptor
 * Functions for calling AUTH API.
 ************************************************************/

var q = require('q');
var request = require('superagent');
var Agent = require('agentkeepalive');

var helpers = require('../../helpers');
var converter = require('../../helpers/lib/api/converter');

var DLSError = helpers.errors.DLSError;

/*********************************
 * Setting Up Module Entry Point
 **********************************/
module.exports = auth;

var keepaliveAgent = new Agent({
  timeout: 60000,
  freeSocketTimeout: 30000
});

//Auth Adaptor Contsructor
function auth() {
  return {
    pisImport: pisImport.bind(this),

    getAllUsers: getAllUsers.bind(this),
    getAllUsersV2: getAllUsersV2.bind(this),
    getUserProfile: getUserProfile.bind(this),
    deleteUserProfile: deleteUserProfile.bind(this),
    updateUserRole: updateUserRole.bind(this),
    getUserClasses: getUserClasses.bind(this),
    getUserClassesV2: getUserClassesV2.bind(this),
    getClassUsers: getClassUsers.bind(this),
    enrollUsertoClass: enrollUsertoClass.bind(this),
    enrollSelftoClass: enrollSelftoClass.bind(this),
    enrollMultiUserstoClass: enrollMultiUserstoClass.bind(this),
    unEnrollMultiUserstoClass: unEnrollMultiUserstoClass.bind(this),
    unEnrollUsertoClass: unEnrollUsertoClass.bind(this),

    getOrgSettings: getOrgSettings.bind(this),
    updateOrgSettings: updateOrgSettings.bind(this),
    generateClassCode: generateClassCode.bind(this),

    getAllJobs: getAllJobs.bind(this),
    getJob: getJob.bind(this),

    createClass: createClass.bind(this),
    updateClass: updateClass.bind(this),
    createMultipleClasses: createMultipleClasses.bind(this),
    deleteClass: deleteClass.bind(this),
    cloneClass: cloneClass.bind(this),
    getAllClasses: getAllClasses.bind(this),
    getParticularClass: getParticularClass.bind(this),
    getParticularShadowClass: getParticularShadowClass.bind(this),
    createClassProductAssociation: createClassProductAssociation.bind(this),
    removeClassProductAssociation: removeClassProductAssociation.bind(this),
    createMultiClassProductAssociations: createMultiClassProductAssociations.bind(this),
    associateMaterialsWithClass: associateMaterialsWithClass.bind(this),
    unassociateMaterialsWithClass: unassociateMaterialsWithClass.bind(this),
    addItemsToShowcaseOfAClass: addItemsToShowcaseOfAClass.bind(this),
    deleteItemsFromShowcaseOfAClass: deleteItemsFromShowcaseOfAClass.bind(this),

    getClassAppdata: getClassAppdata.bind(this),
    putClassAppdata: putClassAppdata.bind(this),
    deleteClassAppdata: deleteClassAppdata.bind(this),

    encodeURLParameter: encodeURLParameter.bind(this),

    createAssignedPath: createAssignedPath.bind(this),
    deleteAssignedPath: deleteAssignedPath.bind(this),
    updateAssignedPath: updateAssignedPath.bind(this),

    //Groups related APIs
    createGroup: createGroup.bind(this),
    getAllGroupsByPath: getAllGroupsByPath.bind(this),
    getAGroup: getAGroup.bind(this),
    updateGroup: updateGroup.bind(this),
    deleteGroup: deleteGroup.bind(this),
    getAllMembersOfAGroup: getAllMembersOfAGroup.bind(this),
    getAllGroupMembersByPath: getAllGroupMembersByPath.bind(this),
    createMultiUserGroupMembership: createMultiUserGroupMembership.bind(this),
    deleteMultiUserGroupMembership: deleteMultiUserGroupMembership.bind(this),
    getMyAllMemberships: getMyAllMemberships.bind(this),
    archiveGroup: archiveGroup.bind(this),
    unarchiveGroup: unarchiveGroup.bind(this),

    //Gradeooks related APIs
    createGradebookMeta: createGradebookMeta.bind(this),
    updateGradebookMeta: updateGradebookMeta.bind(this),
    deleteGradebookMeta: deleteGradebookMeta.bind(this),
    getParticularGradebookMetaOfAClass: getParticularGradebookMetaOfAClass.bind(this),
    getAllGradebooksMetaOfAClass: getAllGradebooksMetaOfAClass.bind(this),
    addGradebookColumns: addGradebookColumns.bind(this),
    updateMultipleGradebookColumns: updateMultipleGradebookColumns.bind(this),
    removeGradebookColumns: removeGradebookColumns.bind(this),
    getParticularColumnOfAGradebook: getParticularColumnOfAGradebook.bind(this),
    getAllColumnsOfAGradebook: getAllColumnsOfAGradebook.bind(this),
    getAllClassesOfAComponent: getAllClassesOfAComponent.bind(this),
    removeAllGradebookColumnsOfCustomComponent: removeAllGradebookColumnsOfCustomComponent.bind(this),

    // Custom Components related APIs
    createCustomComponent: createCustomComponent.bind(this),
    updateCustomComponent: updateCustomComponent.bind(this),
    deleteCustomComponent: deleteCustomComponent.bind(this),
    getParticularCustomComponent: getParticularCustomComponent.bind(this),
    getAllCustomComponents: getAllCustomComponents.bind(this)
  };
}

/*********************************
 * Public Function definitions
 **********************************/

//options = {
//    userid: 'uuid or username',  //optional.
//}
function getUserProfile(options) {
  /* Reference to comproDLS SDK object , contains the following properties
   * 1. self.orgId [String] : organization Id
   * 2. self.token [Object] : DLS token. It has following structure
   *    {
   *      "access_token" : [String]
   *    }
   */
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    var userid = 'me';
    if(options) {
      if(options.userid) { userid = options.userid; }
    }
    // Passed all validations, Contruct API url
    var url = self.config.DEFAULT_HOSTS.AUTH +
              self.config.AUTH_API_URLS.userInfoAPI;
    url = helpers.api.constructAPIUrl(url, { orgId: self.orgId, userId: userid });

    // Contruct parameters
    var params = {};

    // Setup request with URL and Params
    var requestAPI = request.get(url).query(params);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    // Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);
    // Call GET USER INFO Api
    requestAPI.end(function(err, response) {
      if(err) {
        err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
        dfd.reject(err);
      }
      else {
        var res = converter.convertUserResponse({data: response.body});
        dfd.resolve(res);
      }
    });
  }
  return dfd.promise;
}

/**
 * options = {
 *     userid : ""    // dls user id, mandatory
 * }
 */

function deleteUserProfile(options) {
  var self = this;
  var dfd = q.defer();

  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if (options.userid) {
      var userid = options.userid;

      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
        self.config.AUTH_API_URLS.userInfoAPI;
      url = helpers.api.constructAPIUrl(url, { orgId: self.orgId, userId: userid });

      // Setup request with URL
      var requestAPI = request.delete(url);
      if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      // Call DELETE USER API
      requestAPI.end(function (error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(error);
        }
        else { dfd.resolve(response.body); }
      });
    } else {
      err = {};
      err.message = err.description = 'Mandatory parameter userid not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

//options = {
//    search: 'search string',   //optional.
//    lookup: 'string', // Search query (',' separated key value pairs), e.g. key1:val1,key2:val2,key3:val3
//    lookup-operator: 'AND'/'OR', // Operator to use while lookup. Current Possible Value - AND, OR
//    cursor: 'cursor',      //optional, cursor to get next set of groups.
//    limit: number,         //optional, limit the number of Users to fetch at a time.
//    role: 'string'         //optional, to search Users by Role
//    sortField: ['first_name', 'last_name', 'ext_email', 'created', 'roles', ... (other fields of response entity)]
//              Sort the result according to given field. By default is 'last_name’, followed by ‘first_name’ in asc order.
//    sortOrder: ['desc', 'asc']   //optional, By default is 'desc’.
//}
function getAllUsers(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    var queryStr = 'orgid:"' + self.orgId + '"';

    if(options.lookup && options['lookup-operator']) {
      var lookupString = options.lookup;
      lookupString = lookupString.replace(/ext_/ig, '');
      var lookupArray = lookupString.split(',').map(function(item) {
        var lookupItem = item.trim();
        var tempArr = lookupItem.split(':');
        lookupItem = '(' + lookupItem + ' OR ' + tempArr[0] + '.keyword:' + tempArr[1] + ')';
        return lookupItem;
      });
      queryStr = queryStr + ' AND (' + lookupArray.join(' ' + options['lookup-operator'] + ' ') + ')';
    }

    if(options.role) {
      var roleNameString = options.role;
      var roleNameArray = roleNameString.split(',').map(function(item) { return item.trim(); });
      for(var idx in roleNameArray){
        roleNameArray[idx] = 'roles:' + roleNameArray[idx];
      }
      queryStr = queryStr + ' AND (' + roleNameArray.join(' OR ') + ')';
    }

    if(options.search) {
      queryStr = queryStr + ' AND (email:"' + options.search + '" OR first_name:"' + options.search + '" OR last_name:"'
                  + options.search + '" OR username:"' + options.search + '" OR userid:"' + options.search + '")';
    }

    var sortField = options.sortField || '';
    sortField = sortField.replace(/ext_/ig, '').split(',').shift().trim() || 'last_name';
    var sortOrder = options.sortOrder || 'asc';
    if(sortField !== 'created') {
      sortField = sortField + '.keyword';
    }
    var sortObj = {}, sortArr = [];
    sortObj[sortField] = sortOrder;
    sortArr.push(sortObj);

    var queryObj = {
      query: { query_string: { query: queryStr } },
      sort: sortArr
    };

    if(options.cursor) { queryObj.search_after = JSON.parse(options.cursor); }
    if(options.limit) { queryObj.size = options.limit; }
    else { options.limit = 10; } // by default ES returns only 10 elements at max.

    //Passed all validations, Construct API url
    var url = self.config.DEFAULT_HOSTS.INTEGRATION +
              self.config.INTEGRATIONS_API_URLS.queryDataFromSearch;
    url = helpers.api.constructAPIUrl(url, { index: 'users' });

    // Contruct parameters
    var params = {
      query: JSON.stringify(queryObj)
    };

    // Setup request with URL and Params
    var requestAPI = request.get(url).query(params);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    // Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

    // Call GET ALL USER Api
    requestAPI.end(function(err, response) {
      if(err) {
        var esErrOptions = { type: helpers.errors.ERROR_TYPES.API_ERROR, err: err };
        var error = converter.convertElasticsearchErrResponse(esErrOptions);
        dfd.reject(error);
      }
      else {
        var responseObject = { entities: [] };
        responseObject.count = response.body.hits.hits.length;
        if(responseObject.count && (options.limit  === responseObject.count)) {
          var cursor = response.body.hits.hits[response.body.hits.hits.length - 1].sort;
          responseObject.cursor = JSON.stringify(cursor);
        }

        for(var index in response.body.hits.hits) {
          var userEntity = response.body.hits.hits[index]._source;
          var userObj = {
            uuid: userEntity.dls_user_id,
            name: userEntity.first_name + ' ' + userEntity.last_name,
            email: userEntity.email || userEntity.ext_email,
            username: userEntity.userid + '--ACCOUNT',
            created: userEntity.created,
            org: { id: self.orgId }
          };
          if(userEntity.roles) {
            userObj.roles = userEntity.roles;
          }
          if(userEntity.provision_method) {
            userObj.provision_method = userEntity.provision_method;
          }
          if(userEntity.first_name) {
            userObj.first_name = userEntity.first_name;
          }
          if(userEntity.last_name) {
            userObj.last_name = userEntity.last_name;
          }
          if(userEntity.ext_parent_id) {
            userObj.ext_parent_id = userEntity.ext_parent_id;
          }
          if(userEntity.username) {
            userObj.ext_username = userEntity.username;
          }
          if(userEntity.userid) {
            userObj.ext_user_id = userEntity.userid;
          }
          if(userEntity.address) {
            userObj.address = userEntity.address;
          }
          responseObject.entities.push(userObj);
        }
        dfd.resolve(responseObject);
      }
    });
  }
  return dfd.promise;
}

/**
 * This function is used to fetch all the users of a particular org.
 * Params:
 * {
 *   role: 'string'              // Optional
 *   lookup: 'string',           // Optional. Search query (',' separated key-value pairs)
 *   lookup-operator: 'string',  // Optional. Default - 'OR'. Permitted values - [OR]
 *   sortField: 'string',        // Default - 'last_name'.
 *   sortOrder: 'string',        // Default - 'desc'. Permitted values - [desc, asc]
 *   limit: number,              // Optional. Default - 10
 *   cursor: '<cursor>'          // Optional
 * }
 * @param {*} options
 */
function  getAllUsersV2(options) {
  var self = this;

  // Initializing promise
  var deferred = q.defer();

  // Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (error) {
    deferred.reject(error);
  } else {
    // Initialize query object.
    var queryObject = {
      query: { bool: { must: [] } },
      size: options.limit || 10     // (DEFAULT) ES returns only 10 elements at max.
    };

    // Prepare query_string for fetching all the users of a particular school (org).
    var queryStr = 'orgid:"' + self.orgId + '"';

    // Update the query_string to filter the users based on their user-role.
    if (options.role) {
      var roleNameString, roleNameArray;

      roleNameString = options.role;
      roleNameArray = roleNameString.split(',').map(function (item) {
        return item.trim();
      });

      for (var idx in roleNameArray) {
        roleNameArray[idx] = 'roles:' + roleNameArray[idx];
      }
      queryStr = queryStr + ' AND (' + roleNameArray.join(' OR ') + ')';
    }

    // Update the queryObject with the query_string.
    queryObject.query.bool.must.push({
      query_string: { query: queryStr }
    });

    // Update the queryObject to filter the users based on lookup's key-value pairs.
    if (options.lookup && options['lookup-operator']) {
      var lookupString, lookupArray;

      // Update the 'lookupString' to remove the prefix 'ext_' from keys of the key-value pairs.
      lookupString = options.lookup.replace(/ext_/ig, '');
      lookupArray = lookupString.split(',');

      // Iterate over all the key-value pairs and prepare lookupOptions.
      var lookupOptions = { bool: {} };
      for (var index in lookupArray) {
        var lookupItem = lookupArray[index].trim(),
          tempArr = lookupItem.split(':'),
          lookupObject = { wildcard: {} },
          lookupKey, lookupValue;

        /**
         * The suffix '.keyword' is ONLY required for fields of type 'string'.
         * Note: Currently lookup is ONLY supported for fields of type 'string'.
         */
        lookupKey = tempArr[0] + '.keyword';
        lookupValue = tempArr[1];

        // Case-insensitive lookup is currently ONLY SUPPORTED on the field 'ext_email'.
        if (lookupKey === 'email.keyword') {
          lookupObject.wildcard[lookupKey] = { value: lookupValue, case_insensitive: true };
        } else {
          lookupObject.wildcard[lookupKey] = { value: lookupValue, case_insensitive: false };
        }

        if (options['lookup-operator'] === 'OR') {
          if (!lookupOptions.bool.should) { lookupOptions.bool.should = []; }
          lookupOptions.bool.should.push(lookupObject);
        } else {
          /**
           * If the 'lookup-operator' is 'AND', use the 'must' clause.
           * Note: This value is currently NOT SUPPORTED.
           * Prepare error and reject the request.
           */
          var errMsg = 'The value \'AND\' for the field \'lookup-operator\' is currently NOT supported';
          error = {};
          error.message = error.description = errMsg;
          error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);

          deferred.reject(error);
          return deferred.promise;
        }
      }
      queryObject.query.bool.must.push(lookupOptions);
    }

    // Update the queryObject to sort the results based on sortField / sortOrder.
    var sortField, sortOrder, sortObj = {}, sortArr = [];
    sortField = options.sortField || 'last_name';
    sortOrder = options.sortOrder || 'asc';

    // Update the sortField to remove prefix: 'ext_' and trim any unnecessary whitespaces.
    sortField = sortField.replace(/ext_/ig, '').split(',').shift().trim();
    if (sortField !== 'created') {
      sortField = sortField + '.keyword';
    }

    sortObj[sortField] = sortOrder;
    sortArr.push(sortObj);
    queryObject.sort = sortArr;

    // Update the queryObject to fetch the next set of records from ES.
    if (options.cursor) {
      queryObject.search_after = JSON.parse(options.cursor);
    }

    // Passed all validations, Construct API URL
    var url = self.config.DEFAULT_HOSTS.INTEGRATION + self.config.INTEGRATIONS_API_URLS.queryDataFromSearch;
    url = helpers.api.constructAPIUrl(url, { index: 'users' });

    // Setup request with URL and Params
    var params = { query: JSON.stringify(queryObject)};
    var requestAPI = request.get(url).query(params);
    if (self.traceid) {
      requestAPI.set('X-Amzn-Trace-Id', self.traceid);
    }

    // Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

    // Call the ES API to fetch users from ES.
    requestAPI.end(function (err, response) {
      if (err) {
        // Prepare and send error response.
        var esErrOptions = { type: helpers.errors.ERROR_TYPES.API_ERROR, err: err },
          error = converter.convertElasticsearchErrResponse(esErrOptions);

        deferred.reject(error);
      } else {
        // Prepare and send success response.
        var responseObject = {
          entities: [], count: response.body.hits.hits.length
        };

        if (responseObject.count && options.limit === responseObject.count) {
          var cursor = response.body.hits.hits[response.body.hits.hits.length - 1].sort;
          responseObject.cursor = JSON.stringify(cursor);
        }

        for (var index in response.body.hits.hits) {
          var userEntity = response.body.hits.hits[index]._source,
            userObj = {
              uuid: userEntity.dls_user_id,
              name: userEntity.first_name + ' ' + userEntity.last_name,
              email: userEntity.email || userEntity.ext_email,
              username: userEntity.userid + '--ACCOUNT',
              created: userEntity.created,
              org: { id: self.orgId }
            };

          if (userEntity.roles) {
            userObj.roles = userEntity.roles;
          }

          if (userEntity.provision_method) {
            userObj.provision_method = userEntity.provision_method;
          }

          if (userEntity.first_name) {
            userObj.first_name = userEntity.first_name;
          }

          if (userEntity.last_name) {
            userObj.last_name = userEntity.last_name;
          }

          if (userEntity.ext_parent_id) {
            userObj.ext_parent_id = userEntity.ext_parent_id;
          }

          if (userEntity.username) {
            userObj.ext_username = userEntity.username;
          }

          if (userEntity.userid) {
            userObj.ext_user_id = userEntity.userid;
          }

          if (userEntity.address) {
            userObj.address = userEntity.address;
          }

          responseObject.entities.push(userObj);
        }

        deferred.resolve(responseObject);
      }
    });
  }

  return deferred.promise;
}

//options = {
//    userid: 'dlsUserId',  //mandatory
//    target_role: 'string', //mandatory
//    ext_data: { email_template_id: string } //optional
//}
function updateUserRole(options) {
  var self = this;

  // Initializing promise
  var dfd = q.defer();
  // Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(error) { dfd.reject(error); }
  else {
    if(options && options.userid && options.target_role) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                                self.config.AUTH_API_URLS.updateUserRoleAPI;
      url = helpers.api.constructAPIUrl(url, { orgId : self.orgId, userId: options.userid });
      var bodyParams = { ext_data: options.ext_data, target_role: options.target_role };
      // Setup request with URL and Params
      var requestAPI = request.put(url)
                      .set('Content-Type', 'application/json')
                      .set('Accept', 'application/json')
                      .send(bodyParams);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }
      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        }
        else { dfd.resolve(response); }
      });
    } else {
      var err = {};
      err.message = err.description = 'Mandatory parameter options, userid or target_role, not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }

  return dfd.promise;
}

//options = {
//    userid: 'uuid or username',  //optional.
//    search: 'search string',   //optional.
//    details: true/false,  //optional, includes products & assignments information of class.
//    sortField: ['startdate', 'enddate', 'title']       //optional, By default is 'title’.
//    sortOrder: ['desc', 'asc'] //optional, By default is 'desc’.
//    enrollmentType: ['creator', 'teacher', 'student'] //optional, bydefault send all classes.
//    teacherId: 'string' //optional, get classes of a particular teacher only.
//    cursor: 'cursor'      //optional, cursor to get next set of classes
//    limit: integer      //optional, Number of entities to fetch at once
//    bundleDetails: true/false      //optional
//}
function getUserClasses(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    var userid = 'me';
    if(options) {
      if(options.userid) { userid = options.userid; }
    }
    // Passed all validations, Construct API url
    var url = self.config.DEFAULT_HOSTS.AUTH +
              self.config.AUTH_API_URLS.getUserClassesAPI;
    url = helpers.api.constructAPIUrl(url, { orgId: self.orgId, userId: userid });

    // Contruct parameters
    var params = {};
    if(options) {
      if(options.search) { params.search = 'title:' + options.search; }
      if(options.details) { params.details = options.details; }
      if(options.enrollmentType) { params.enrollmentType = options.enrollmentType; }
      if(options.sortField) { params.sortField = options.sortField; }
      if(options.sortOrder) { params.sortOrder = options.sortOrder; }
      if(options.cursor) { params.cursor = options.cursor; }
      if(options.limit) { params.limit = options.limit; }
      if(options.teacherId) { params.lookup = 'class.class.instructor.uuid:' + options.teacherId; }
      if(options.bundleDetails) { params.bundleDetails = options.bundleDetails; }
    }

    // Setup request with URL and Params
    var requestAPI = request.get(url).query(params);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    // Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

    // Call GET ALL USER Api
    requestAPI
    .agent(keepaliveAgent)
    .end(function(err, response) {
      if(err) {
        err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
        dfd.reject(err);
      }
      else { dfd.resolve(response.body); }
    });
  }
  return dfd.promise;
}

/**
 * @param {
 *  userid: 'uuid or username', // Mandatory
 *  shadow: true/false,         // Optional, filter shadow enrollments
 *  hidden: true/false,         // Optional, filter hidden enrollments
 *  status_active: true/false,  // Optional, filter for status_active enrollments
 *  status_ended: true/false,   // Optional, filter for status_ended enrollments
 *  status_expired: true/false, // Optional, filter for status_expired enrollments
 *  details: true/false,        // Optional, includes products & meta information of classes
 *  bundleDetails: true/false   // Optional, includes products, bundles & meta information of classes
 *  limit: integer,             // Optional, Number of entities to be fetched
 *  cursor: 'cursor'            // Optional, cursor to get next set of enrollments
 * } options
 */
function getUserClassesV2(options) {
  var self = this, orgId = self.orgId, token = self.token;

  // Initializing promise
  var deferred = q.defer();

  // Validations
  var error = helpers.validations.isAuthenticated(orgId, token);

  if (error) {
    deferred.reject(error);
  } else if (options && options.userid) {
    var userId = options.userid;

    // Passed all validations, Construct API url
    var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.getUserClassesV2API;
    url = helpers.api.constructAPIUrl(url, { orgid: orgId, userid: userId });

    // Contruct query parameters
    var params = {};
    if (options) {
      if (options.shadow !== undefined) { params.shadow  = options.shadow; }
      if (options.hidden !== undefined) { params.hidden  = options.hidden; }
      if (options.status_active) { params.status_active  = options.status_active; }
      if (options.status_ended) { params.status_ended  = options.status_ended; }
      if (options.status_expired) { params.status_expired  = options.status_expired; }
      if (options.details) { params.details = options.details; }
      if (options.bundleDetails) { params.bundleDetails = options.bundleDetails; }
      if (options.limit) { params.limit = options.limit; }
      if (options.cursor) { params.cursor = options.cursor; }
    }

    // Setup request with URL and Params
    var requestAPI = request.get(url).query(params);
    if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    // Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, token);

    // Call GET User Class-Enrollments API
    requestAPI
    .agent(keepaliveAgent)
    .end(function(error, response) {
      if (error) {
        error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
        deferred.reject(error);
      } else {
        deferred.resolve(response.body);
      }
    });
  } else {
    error = {};
    error.message = error.description = 'Required parameter \'userid\' is not found in request options.';
    error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
    deferred.reject(error);
  }

  return deferred.promise;
}

/**
 * options = {
 *    classid: 'classid',
 *    search: 'string',         // (optional) Search Query
 *    cursor: 'string',         // (optional) Cursor string to fetch next set of Users
 *    limit: 'integer'          // (optional) Number of users to fetch at a time.
 *    sortField: 'string'       // (optional) Sort the result according to given field. By default is 'email’.
 *    sortOrder: 'string'       // (optional) Sort the result according to given order. By default is 'desc’.
 * }
 */
function getClassUsers(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.classid) {
      // Passed all validations, Construct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.getClassUsersAPI;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classid
      });

      // Setup params
      var params = {};
      if(options.search) { params.search = options.search; }
      if(options.cursor) { params.cursor = options.cursor; }
      if(options.limit) { params.limit = options.limit; }
      if(options.sortField) { params.sortField = options.sortField; }
      if(options.sortOrder) { params.sortOrder = options.sortOrder; }

      // Setup request with URL and Params
      var requestAPI = request.get(url).query(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      // Call GET ALL USER Api
      requestAPI
        .agent(keepaliveAgent)
        .end(function(err, response) {
          if(err) {
            err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
            dfd.reject(err);
          }
          else {
            response.body.entities = converter.convertEnrollmetsResponse({data: response.body.entities}) ;
            dfd.resolve(response.body);
          }
        });
    } else {
      err = {};
      err.message = err.description = 'Required parameter classid is not defined.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

//options = {
//    extension: 'csv',
//    import_type: 'users'/'groups'/'user-group-enrollment',
//    upFile: '' // path to csv file to be uploaded
//}
function pisImport(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    // Passed all validations, Construct API url
    var url = self.config.DEFAULT_HOSTS.AUTH +
              self.config.AUTH_API_URLS.pisImportAPI;
    url = helpers.api.constructAPIUrl(url, {'orgId' : self.orgId});
    // Contruct parameters
    var params = {};
    var upfile;
    if(options) {
      if(options.extension) { params.extension = options.extension; }
      if(options.import_type) { params.import_type = options.import_type; }
      if(options.upfile) { upfile = options.upfile; }
    }

    // Setup request with URL and Params
    var requestAPI = request.post(url).query(params)
                     .set('Content-Type', 'multipart/form-data')
                     .attach('upfile', upfile);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    // Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

    // Call PIS IMPORT Api
    requestAPI.end(function(err, response) {
      if(err) {
        err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
        dfd.reject(err);
      }
      else { dfd.resolve(response.body); }
    });
  }
  return dfd.promise;
}

//options = {
//	field: '' // apps / lti / sis / pis / product[ANY ONE]
//}
function getOrgSettings(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    // Passed all validations, Construct API url
    var url = self.config.DEFAULT_HOSTS.AUTH +
              self.config.AUTH_API_URLS.getSettings;
    url = helpers.api.constructAPIUrl(url, {orgId: self.orgId});

    // Contruct parameters
    var params = {};
    if(options && options.field) {
      url = self.config.DEFAULT_HOSTS.AUTH +
            self.config.AUTH_API_URLS.getSettingsField;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, field: options.field
      });
    }

    // Setup request with URL and Params
    var requestAPI = request.get(url).query(params);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    // Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

    // Call SIS IMPORT Api
    requestAPI.end(function(err, response) {
      if(err) {
        err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
        dfd.reject(err);
      }
      else { dfd.resolve(response.body); }
    });
  }
  return dfd.promise;
}

//options = {
//	body: {} // the top level settings field to be updated.
//}
function updateOrgSettings(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    // Passed all validations, Construct API url
    var url = self.config.DEFAULT_HOSTS.AUTH +
              self.config.AUTH_API_URLS.getSettings;
    url = helpers.api.constructAPIUrl(url, {orgId: self.orgId});
    // Setup request with URL and Params
    var requestAPI = request.put(url);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    if(options.body) {
      if(options.body.sis && (! options.body.sis.productid)) {
        options.body.sis.productid = [];
      }
      requestAPI.send(options.body);
    }
    // Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

    // Call SIS IMPORT Api
    requestAPI.end(function(err, response) {
      if(err) {
        err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
        dfd.reject(err);
      }
      else { dfd.resolve(response.body); }
    });
  }
  return dfd.promise;
}

//options = {
//	classid: "string"
//}
function generateClassCode(options) {
  var self = this, err;
  // Initializing promise
  var dfd = q.defer();
  if(options && options.classid) {
    // Validations
    err = helpers.validations.isAuthenticated(self.orgId, self.token);
    if(err) { dfd.reject(err); }
    else {
      // Passed all validations, Construct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                              self.config.AUTH_API_URLS.generateClassCode;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classid
      });
      // Setup request with URL and Params
      var requestAPI = request.post(url);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      // Call Update class settings Api
      requestAPI.end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    }
  } else {
    err = {};
    err.message = err.description = 'classid not found in request options.';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }
  return dfd.promise;
}

/**
 * {
    accountId: 'string'  //mandatory
    extUserId: 'string',  //mandatory
    jobType: 'string'  //optional queryParam, Use this param to get  All Jobs of a particular jobType.
    details: boolean //optional queryParam, Use this param to add extension data in response of each job.
  }
 */
function getAllJobs(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();

  if(options && options.accountId && options.extUserId) {
    // Passed all validations, Contruct API url
    var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.getAllJobs;
    url = helpers.api.constructAPIUrl(url, { accountId : options.accountId, extUserId: options.extUserId });

    var params = {};
    if(options.jobType) { params.jobType = options.jobType; }
    if(options.details) { params.details = options.details; }

    // Setup request with URL and Params
    var requestAPI = request.get(url).query(params);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI.end(function(error, response) {
      if(error) {
        err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
        dfd.reject(err);
      }
      else { dfd.resolve(response.body); }
    });
  } else {
    var err = {};
    err.message = err.description = 'accountId or extUserId not found in request options.';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }

  return dfd.promise;
}

/**
 * options = {
    accountId: 'string', //mandatory
    extUserId: 'string', //mandatory
    jobId: 'string', //mandatory
    jobType: 'string' //mandatory
  }
 */
function getJob(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();

  if(options && options.accountId && options.extUserId && options.jobId && options.jobType) {
    // Passed all validations, Contruct API url
    var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.getJob;
    url = helpers.api.constructAPIUrl(url, { accountId : options.accountId, extUserId: options.extUserId,
      jobId: options.jobId });
    var params = { jobType: options.jobType };

    // Setup request with URL and Params
    var requestAPI = request.get(url).query(params);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI.end(function(error, response) {
      if(error) {
        err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
        dfd.reject(err);
      }
      else { dfd.resolve(response.body); }
    });
  } else {
    var err = {};
    err.message = err.description = 'accountId or extUserId or jobType or jobId or not found in request options.';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }

  return dfd.promise;
}


/**
 * @param {*} options {
 *  search: 'search string',        // Optional
 *  sortField: ['startdate', 'enddate', 'title', 'created', 'tagname_1'] // Optional
 *                                  // Default: 'created’.
 *  sortOrder: ['desc', 'asc']      // Optional, Default: 'desc’.
 *  cursor: 'cursor'                // Optional, cursor to get next set of groups.
 *  limit: integer,                 // Optional, limit number of Classes in response.
 *  lookup: 'string',               // Optional, Exact query search (',' separated key value pairs).
 *                                  // E.g. key1:val1,key2:val2
 *  lookup-operator: ['OR', 'AND']  // Optional
 * }
 * @returns {entities: [{}, {}, ...], count: <integer>, cursor: <string>}
 */
function getAllClasses(options) {
    var self = this;

    //Initializing promise
    var dfd = q.defer();

    //Validations
    var err = helpers.validations.isAuthenticated(self.orgId, self.token);

    if(err) {
        dfd.reject(err);
    } else {
        var queryStr = 'orgid:"' + self.orgId + '"';

        if (options.lookup && options['lookup-operator']) {
          var lookupString = options.lookup;
          var lookupArray = lookupString.split(',').map(function (item) {
            var lookupItem = item.trim();
            var tempArr = lookupItem.split(':');
            lookupItem = '(' + tempArr[0] + '.keyword:' + tempArr[1] + ')';
            return lookupItem;
          });
          queryStr += ' AND (' + lookupArray.join(' ' + options['lookup-operator'] + ' ') + ')';
        }

        if(options.search) {
          queryStr = queryStr + ' AND (title:"' + options.search + '" OR class.instructor.first_name:"' + options.search +
                      '" OR class.instructor.last_name:"' + options.search + '" OR description:"' + options.search + '")';
        }

        var sortField = options.sortField || '';
        sortField = sortField.replace(/ext_/ig, '').split(',').shift().trim() || 'created';

        if(sortField === 'enddate' || sortField === 'startdate') {
          sortField = 'class.' + sortField;
        }

        if(sortField === 'title') {
          sortField = sortField + '.keyword';
        }

        if (sortField === 'tagname_1') {
          sortField = sortField + '.keyword';
        }

        var sortOrder = options.sortOrder || 'desc';
        var sortObj = {}, sortArr = [];
        sortObj[sortField] = sortOrder;
        sortArr.push(sortObj);

        var queryObj = {
          query: { query_string: { query: queryStr } },
          sort: sortArr
        };

        if(options.cursor) { queryObj.search_after = JSON.parse(options.cursor); }
        if(options.limit) { queryObj.size = options.limit; }
        else { options.limit = 10; } // by default ES returns only 10 elements at max.

        //Passed all validations, Construct API url
        var url = self.config.DEFAULT_HOSTS.INTEGRATION +
                  self.config.INTEGRATIONS_API_URLS.queryDataFromSearch;
        url = helpers.api.constructAPIUrl(url, { index: 'classes' });

        // Contruct parameters
        var params = {
          query: JSON.stringify(queryObj)
        };

        //Setup request with URL and Params
        var requestAPI = request.get(url).query(params);
        if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

        //Setup token in Authorization header
        requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

        //Call GET ALL USER Api
        requestAPI
          .agent(keepaliveAgent)
          .end(function(err, response) {
            if(err) {
              var esErrOptions = { type: helpers.errors.ERROR_TYPES.API_ERROR, err: err };
              var error = converter.convertElasticsearchErrResponse(esErrOptions);
              dfd.reject(error);
            } else {
              var responseObject = { entities: [] };
              responseObject.count = response.body.hits.hits.length;
              if(responseObject.count && (options.limit  === responseObject.count)) {
                var cursor = response.body.hits.hits[response.body.hits.hits.length - 1].sort;
                responseObject.cursor = JSON.stringify(cursor);
              }
              for(var index in response.body.hits.hits) {
                var classEntity = response.body.hits.hits[index]._source;
                var classObj = {
                  uuid: classEntity.classid,
                  created: classEntity.created,
                  modified: classEntity.modified,
                  path: classEntity.path,
                  category: classEntity.category,
                  class: {
                    enddate: classEntity.class.enddate,
                    instructor: {
                      name: classEntity.class.instructor.first_name + ' ' + classEntity.class.instructor.last_name,
                      last_name: classEntity.class.instructor.last_name,
                      first_name: classEntity.class.instructor.first_name,
                      uuid: classEntity.class.instructor.dls_user_id,
                      email: classEntity.class.instructor.email,
                      username: classEntity.class.instructor.userid + '--ACCOUNT'
                    },
                    startdate: classEntity.class.startdate
                  },
                  'class.settings.active': classEntity['class.settings.active'],
                  class_code: classEntity.class_code,
                  class_ownership: classEntity.class_ownership || { owner_status: 'ENROLLED', model: 'STRICT' },
                  description: classEntity.description,
                  provision_method: classEntity.class.provision_method,
                  title: classEntity.title,
                  analyticsharingmodel: classEntity.analyticsharingmodel,
                  analytics_score_aggregation_type: classEntity.analytics_score_aggregation_type,
                  hidden: classEntity.hidden,
                  studentCount: classEntity.studentCount,
                  teacherCount: classEntity.teacherCount
                };

                if(classEntity.limits){
                  classObj.limits = classEntity.limits;
                }
                if (classEntity.hasOwnProperty('assignedPathCount')) {
                  classObj.assignedPathCount = classEntity.assignedPathCount;
                }

                /**
                 * Add class-tag association specific fields
                 */
                for (var tagNum = 1; tagNum <= 10; tagNum++) {
                  var tagid = 'tagid_' + tagNum;

                  if (classEntity[tagid]) {
                    classObj[tagid] = classEntity[tagid];
                    classObj['tagname_' + tagNum] = classEntity['tagname_' + tagNum];
                    classObj['taglookup_' + tagNum] = classEntity['taglookup_' + tagNum];
                  }
                }

                responseObject.entities.push(classObj);
              }
              dfd.resolve(responseObject);
            }
        });
    }
    return dfd.promise;
}


//options = {
//    classId: 'class uuid'
//}
function getParticularClass(options) {
    var self = this;

    //Initializing promise
    var dfd = q.defer();

    //Validations
    var err = helpers.validations.isAuthenticated(self.orgId, self.token);
    if(err) {
        dfd.reject(err);
    } else {
        if(options && options.classId) {
            //Passed all validations, Contruct API url
            var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.getParticularClassAPI;
            url = helpers.api.constructAPIUrl(url,  { orgId: self.orgId, classId: options.classId } );

            var requestAPI = request.get(url);
            if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

            //Setup token in Authorization header
            requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

            requestAPI
              .agent(keepaliveAgent)
              .end(function(err, response) {
                  if(err) {
                      err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
                      dfd.reject(err);
                  } else {
                    dfd.resolve(response.body);
                  }
              });
        } else {
            err = {};
            err.message = err.description = 'classId not found in request options.';
            err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
            dfd.reject(err);
        }
    }
    return dfd.promise;
}

//options = {
//  ext_classid: 'ext classid' //mandatory
//}
function getParticularShadowClass(options) {
  var self = this;

  //Initializing promise
  var dfd = q.defer();

  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) {
    dfd.reject(err);
  }
  else {
    if(options && options.ext_classid) {
      //Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.getParticularShadowClassAPI;
      url = helpers.api.constructAPIUrl(url,  { orgId: self.orgId, extClassId: options.ext_classid } );

      var requestAPI = request.get(url);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        }
        else {
          dfd.resolve(response.body);
        }
      });
    } else {
      err = {};
      err.message = err.description = 'ext_classid not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

//options = {
//    classId: 'class uuid',
//    productcode: 'productcode'
//}
function createClassProductAssociation(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.classId && options.productcode) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.classProductAssociation;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classId, productcode: options.productcode
      });

      // Setup request with URL and Params
      var requestAPI = request.post(url)
                       .set('Content-Type', 'application/json')
                       .set('Accept', 'application/json');
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    } else {
      err = {};
      err.message = err.description = 'classId or productcode not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/**
 * @param {
 *   *classId: 'string',
 *   *body: {
 *     productcodes: ['string'],
 *     bundlecodes: ['string'],
 *   }
 * } options
 */
function associateMaterialsWithClass(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.classId && options.body && (options.body.productcodes
      || options.body.bundlecodes)) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.classMaterialAssociation;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classId
      });
      // Setup request with URL and Params
      var requestAPI = request.post(url)
                       .set('Content-Type', 'application/json')
                       .set('Accept', 'application/json');
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.agent(keepaliveAgent).end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    } else {
      err = {};
      err.message = err.description = 'classId or productcodes or bundlecodes not found in'
        + 'request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/**
 * @param {
 *   *classId: string,
 *   *body: {
 *    'productcodes' :['string'],
 *    'bundlecodes' : ['string']
 *    }
 * } options
 */
function unassociateMaterialsWithClass(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.classId && options.body &&
      (options.body.productcodes || options.body.bundlecodes)) {
      // Passed all validations, Contruct API url
      var url= self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.classMaterialAssociation;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classId
      });
      // Setup request with URL and Params
      var requestAPI = request.delete(url)
                       .set('Content-Type', 'application/json')
                       .set('Accept', 'application/json');

      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.agent(keepaliveAgent).end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    } else {
      err = {};
      const msg = 'classId or productcodes or bundlecodes not found in request options.';
      err.message = msg;
      err.description = msg;
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

//options = {
//    classId: 'class uuid',
//    productcode: 'product code'
//}
function removeClassProductAssociation(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.classId && options.productcode) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.classProductAssociation;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classId, productcode: options.productcode
      });

      // Contruct parameters
      var params = {};

      // Setup request with URL and Params
      var requestAPI = request.delete(url).query(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    } else {
      err = {};
      err.message = err.description = 'classId or productcode not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/**
 * This function creates multiple class-product associations.
 * @param options {
 *  *classId      : <string>,
 *  *productcodes : [<string>] // Min: 1, Max: 50
 * }
 * Note: Fields marked with '*' are mandatory.
 */
function createMultiClassProductAssociations(options) {
  var deferred = q.defer();
  var self = this;
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);

  if (error) {
    deferred.reject(error);
  } else if (options && options.classId && options.productcodes) {
    // Passed all validations, Contruct API url
    var defaultHostPath = self.config.DEFAULT_HOSTS.AUTH;
    var bulkCPAssociationAPIPath = self.config.AUTH_API_URLS.multiClassProductAssociations;

    var url = defaultHostPath + bulkCPAssociationAPIPath;
    var bodyParams = { productcodes: options.productcodes };

    url = helpers.api.constructAPIUrl(url, { orgId: self.orgId, classId: options.classId });

    // Setup request with URL and Params
    var requestAPI = request.post(url)
                      .set('Content-Type', 'application/json')
                      .set('Accept', 'application/json')
                      .send(bodyParams);

    if (self.traceid) {
      requestAPI.set('X-Amzn-Trace-Id', self.traceid);
    }

    // Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

    requestAPI.end(function(err, response) {
      if (err) {
        error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
        deferred.reject(error);
      } else {
        deferred.resolve(response.body);
      }
    });
  } else {
    error = {};
    error.message = error.description = 'Missing mandaotry fields \'classId\' or \'productcodes\' in request.';
    error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
    deferred.reject(error);
  }

  return deferred.promise;
}

/*options = {
  classid: 'string'
}*/
function getClassAppdata(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.classid) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.ClassAppdata;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classid: options.classid
      });
      //Setup request with URL
    var requestAPI = request.get(url);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    //Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

    //Call Class Appdata Api
    requestAPI.end(function(err, response) {
      if(err) {
        err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
        dfd.reject(err);
      } else {
        dfd.resolve(response.body);
      }
    });
    } else {
      err = {};
      err.message = err.description = 'classid  not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*options = {
  classid: 'string',
  appdata: {}
}*/

function putClassAppdata(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.classid && options.appdata) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.ClassAppdata;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classid: options.classid
      });

      // Setup request with URL and Params
      var requestAPI = request.put(url)
                       .set('Content-Type', 'application/json')
                       .set('Accept', 'application/json')
                       .send(options.appdata);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    } else {
      err = {};
      err.message = err.description = 'classid or appdata not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*options = {
  classid: 'string'
}*/

function deleteClassAppdata(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.classid) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.ClassAppdata;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classid: options.classid
      });

      // Setup request with URL and Params
      var requestAPI = request.delete(url);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    } else {
      err = {};
      err.message = err.description = 'classid not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

//options = {
//    classid: '', //Class Id
//    userid: '', //User Id
//};
function enrollUsertoClass(options) {
    var self = this;
  var err = {};
    //Initializing promise
    var dfd = q.defer();
  if(options && options.classid && options.userid) {
    //Validations
    err = helpers.validations.isAuthenticated(self.orgId, self.token);
    if(err) {
      dfd.reject(err);
    } else {
      //Passed all validations, Construct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.enrollUsertoClass;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId,
        classId: options.classid,
                userId: options.userid
      });

      //Contruct parameters
      var params = {};

      //Setup request with URL and Params
      var requestAPI = request.post(url)
                              .set('Content-Type', 'application/json')
                              .set('Accept', 'application/json')
                              .query(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      //Call GET Product by it's code Api
      requestAPI
      .agent(keepaliveAgent)
      .end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        } else {
          dfd.resolve(response.body);
        }
      });
    }
  } else {
    err.message = err.description = 'Mandatory parameter classid or userid not found in request options';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }
    return dfd.promise;
}

//options = {
//    classid: '', //Class Id
//    classrole: ''
//};
function enrollSelftoClass(options) {
  var self = this;
  var err = {};
  //Initializing promise
  var dfd = q.defer();
  if(options && options.classid) {
    //Validations
    err = helpers.validations.isAuthenticated(self.orgId, self.token);
    if(err) {
      dfd.reject(err);
    } else {
      //Passed all validations, Construct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.enrollSelftoClass;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId,
        classId: options.classid
      });

      var params = { classrole: options.classrole };
      //Setup request with URL and Params
      var requestAPI = request.post(url)
                              .set('Content-Type', 'application/json')
                              .set('Accept', 'application/json')
                              .send(params);

      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      //Call GET Product by it's code Api
      requestAPI
      .agent(keepaliveAgent)
      .end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        } else {
          dfd.resolve(response.body);
        }
      });
    }
  }
  else {
    err.message = err.description = 'Mandatory parameter classid not found in request options';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }
  return dfd.promise;
}

//options = {
//    classid: '', //Class Id
//    users: ['dls-userid1', 'dls-userid-2'] //Users Id
//};
function enrollMultiUserstoClass(options) {
  var self = this;
  var err = {};
  //Initializing promise
  var dfd = q.defer();
  if(options && options.classid && options.users) {
    //Validations
    err = helpers.validations.isAuthenticated(self.orgId, self.token);
    if(err) {
      dfd.reject(err);
    } else {
      //Passed all validations, Construct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.enrollMultiUserstoClass;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId,
        classId: options.classid
      });

      //Contruct parameters
      var params = {
        users: options.users
      };
      //Setup request with URL and Params
      var requestAPI = request.post(url)
                              .set('Content-Type', 'application/json')
                              .set('Accept', 'application/json')
                              .send(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      //Call GET Product by it's code Api
      requestAPI
      .agent(keepaliveAgent)
      .end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        } else {
          dfd.resolve(response.body);
        }
      });
    }
  } else {
    err.message = err.description = 'Mandatory parameter classid or users ' +
        'array not found in request options';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }
  return dfd.promise;
}

//options = {
//    classid: '', //Class Id
//    users: ['dls-userid1', 'dls-userid-2'] //Users Id
//};
function unEnrollMultiUserstoClass(options) {
  var self = this;
  var err = {};
  //Initializing promise
  var dfd = q.defer();
  if(options && options.classid && options.users) {
    //Validations
    err = helpers.validations.isAuthenticated(self.orgId, self.token);
    if(err) {
      dfd.reject(err);
    } else {
      //Passed all validations, Construct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.enrollMultiUserstoClass;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId,
        classId: options.classid
      });

      //Contruct parameters
      var params = {
        users: options.users
      };
      //Setup request with URL and Params
      var requestAPI = request.delete(url)
                              .set('Content-Type', 'application/json')
                              .set('Accept', 'application/json')
                              .send(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      //Call GET Product by it's code Api
      requestAPI.end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        } else {
          dfd.resolve(response.body);
        }
      });
    }
  } else {
    err.message = err.description = 'Mandatory parameter classid or users ' +
        'array not found in request options';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }
  return dfd.promise;
}

//options = {
//    classid: '', //Class Id
//    userid: '', //User Id
//};
function unEnrollUsertoClass(options) {
    var self = this;
  var err = {};
    //Initializing promise
    var dfd = q.defer();
  if(options && options.classid && options.userid) {
    //Validations
    err = helpers.validations.isAuthenticated(self.orgId, self.token);
    if(err) {
      dfd.reject(err);
    } else {
      //Passed all validations, Construct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.enrollUsertoClass;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId,
        classId: options.classid,
                userId: options.userid
      });

      //Contruct parameters
      var params = {};

      //Setup request with URL and Params
      var requestAPI = request.delete(url).query(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      //Call GET Product by it's code Api
      requestAPI.end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        } else {
          dfd.resolve(response.body);
        }
      });
    }
  } else {
    err.message = err.description = 'Mandatory parameter classid or userid not found in request options';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }
    return dfd.promise;
}

//options = ['parameter1', 'parameter2']
function encodeURLParameter(options) {
  var response = {};
  for(var param in options) {
    response[options[param]] = encodeURIComponent(options[param]);
  }
  return response;
}

/**
 * options = {
 * title: 'class title',
 * startdate: 'Epoch(Unix) timestamp in milliseconds',
 * enddate: 'Epoch(Unix) timestamp in milliseconds',
 * description: '',                          // Optional field
 * class_ownership: 'STRICT' / 'NO_OWNER',   // Default - STRICT, Optional field
 * ext_data: {}                              // Optional
 * analyticsharingmodel: ''                  // Optional - Valid values: ['NOINHERIT_SYNCBACK']
 * analytics_score_aggregation_type: ''      // Optional - Valid values: ['best'/'first'/'last']
 * limits: {"los": number, "students": number}   // Optional field
 * }
 */
function createClass(options) {
    var self = this;

    //Initializing promise
    var dfd = q.defer();

    //Validations
    var err = helpers.validations.isAuthenticated(self.orgId, self.token);
    if(err) {
        dfd.reject(err);
    } else {
        if(options && options.title && options.startdate && options.enddate) {
            //Passed all validations, Contruct API url
            var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.createClass;
            url = helpers.api.constructAPIUrl(url,  { orgId: self.orgId });

            //Contruct parameters
            var params = {
              title: options.title,
              startdate: options.startdate,
              enddate: options.enddate
            };

            if(options.description){ params.description = options.description; }
            if(options.class_ownership){ params.class_ownership = options.class_ownership; }
            if(options.ext_data){ params.ext_data = options.ext_data; }
            if(options.analyticsharingmodel){ params.analyticsharingmodel = options.analyticsharingmodel; }
            if(options.limits){ params.limits = options.limits; }

            //Setup request with URL and Params
            var requestAPI = request.post(url).send(params);
            if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

            //Setup token in Authorization header
            requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

            requestAPI
            .agent(keepaliveAgent)
            .end(function(err, response) {
                if(err) {
                    err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
                    dfd.reject(err);
                } else {
                  var res = converter.convertClassResponse({data: response.body}) ;
                  dfd.resolve(res);
                }
            });
        } else {
            err = {};
            err.message = err.description = 'title or startdate or enddate not found in request options.';
            err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
            dfd.reject(err);
        }
    }
    return dfd.promise;
}

//options = {
//    classid: 'class id',
//    title: 'class title', //Optional field
//    startdate: 'Epoch(Unix) timestamp in milliseconds', //Optional field
//    enddate: 'Epoch(Unix) timestamp in milliseconds', //Optional field
//    description: '',    //Optional field
//    ext_data: ''        //Optional field
//    analytics_score_aggregation_type: ''      // Optional - Valid values: ['best'/'first'/'last']
//    limits: {"los": number, "students": number}   // Optional field
//}
function updateClass(options) {
    var self = this;

    //Initializing promise
    var dfd = q.defer();

    //Validations
    var err = helpers.validations.isAuthenticated(self.orgId, self.token);
    if(err) {
        dfd.reject(err);
    } else {
        if(options && options.classid)
        {
            //Passed all validations, Contruct API url
            var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.specificClass;
            url = helpers.api.constructAPIUrl(url,  { orgId: self.orgId, classId: options.classid });

            //Setup request with URL and Params
            var requestAPI = request.put(url).send(options);
            if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

            //Setup token in Authorization header
            requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

            requestAPI
            .agent(keepaliveAgent)
            .end(function(err, response) {
                if(err) {
                    err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
                    dfd.reject(err);
                } else {
                    dfd.resolve(response.body);
                }
            });
        } else {
            err = {};
            err.message = err.description = 'Mandatory parameter \'classid\' is not found in request options.';
            err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
            dfd.reject(err);
        }
    }
    return dfd.promise;
}

/** options =
 *{
  "space_title": "string",
  "skip_email_to_actor": true/false,     // optional, default false
  "ext_data": {},                        // optional,
  "classes": [
    {
      "title": "class tiltle",
      "startdate": 'Epoch(Unix) timestamp in milliseconds',
      "enddate": 'Epoch(Unix) timestamp in milliseconds',
      "rowId": 'string with max limit 3 characters,
      "description": "string",
      "ext_data": {},                    // optional
      "model": "STRICT",
      "analyticsharingmodel":"NOINHERIT_SYNCBACK"  // optional
      "analytics_score_aggregation_type":"first/best/last"  // optional
      limits: {los: number, students: number}   // Optional field
      "owner": {
        "userid": "string" //Mandatory if model is 'STRICT'
      },
      "teachers": [
        {
          "userid": "string",
          "email": "string"
          "first_name": "string"
          "last_name": "string"
          "userid": "string"             // optional
          "ext_user_id": "string"        // optional
          "dls_org_status": "string"     // optional
          "ext_account_status": "string" // optional
      ],
      "products": [                      // optional
        {
          "productcode": "string",       //mandatory
          "title": ""
        },
        {
          "productcode": "string",       //mandatory
          "title": ""
        }
      ],
      "bundles": [                      // optional
        {
          "bundlecode": "string",       //mandatory
        },
        {
          "bundlecode": "string",       //mandatory
        }
      ]
    }
  ],
  "clone_classes": [
    {
      "title": "string",
      "startdate": 0,
      "enddate": 0,
      "instructor": "string",
      "rowId": "string",
      "classid": "string",
      "clone_settings": {
        "students": true,
        "teachers": true,
        "products": true,
        "bundles": true,
        "groups": true,
        "assigned_paths": true,
        "tags": true,
        "analyticsharingmodel": true,
        "analytics_score_aggregation_type": true,
        "ext_data": true,
        "limits": true,
        "skip_assigned_path_create_notification": true,
        "advanced": {
          "students": [
            {
              "ext_user_id": "string",
              "invite-students": <boolean>,
              "first_name": "string",
              "last_name": "string",
              "email": "string",
              "dls_org_status": "string",
              "ext_account_status": "string"
            }
          ],
          "teachers": [
            {
              "ext_user_id": "string",
              "invite-teachers": <boolean>,
              "first_name": "string",
              "last_name": "string",
              "email": "string",
              "dls_org_status": "string",
              "ext_account_status": "string"
            }
          ]
          "groups": [ { "groupid": "string" } ],
          "assigned_paths": [
            {
              "assigned_path_id": "string",
              "startdate": 0,
              "duedate": 0
            }
          ],
          "products": [ { "productcode": "string" } ],
          "bundles": [ { "bundlecode": "string" } ],
          "analyticsharingmodel": "string"                 // Valid values: ['NOINHERIT_SYNCBACK']
          "analytics_score_aggregation_type": "string",     // Valid values: ['best', 'first', 'last']
          "limits": {los: number, students: number}   // Optional field
        }
      }
    }
  ]
}
 */
function createMultipleClasses(options) {
  var self = this;

  //Initializing promise
  var dfd = q.defer();

  //Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (err) { dfd.reject(err); }
  else {
    if ((options.classes && options.classes.length > 0) ||
      (options.clone_classes && options.clone_classes.length > 0)) {

      //Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.createMultipleClasses;
      url = helpers.api.constructAPIUrl(url, {
          orgId: self.orgId
      });

      //Setup request with URL and Params and Query
      var requestAPI = request.post(url).send(options);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
      .agent(keepaliveAgent)
      .end(function (err, response) {
        if (err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    }
    else {
      err = {};
      err.message = err.description = 'Mandatory parameters - [classes, clone_classes], ' +
                                      'not found in request options';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/**
 * @param {*classid: <string>,
 *   *body:{ audit: <boolean> }
 * } options
 */
function deleteClass(options) {
  var self = this;
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else if(options && options.classid && options.body) {
    // Passed all validations, Contruct API url
    var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.specificClass;
    url = helpers.api.constructAPIUrl(url, { orgId: self.orgId, classId: options.classid });

    // Setup request with URL and Params
    var requestAPI = request.delete(url)
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json')
    .send(options.body);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    //Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

    requestAPI.end(function (error, response) {
      if(error) {
        err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
        dfd.reject(err);
      }
      else { dfd.resolve(response.body); }
    });
  }
  else {
    err = {};
    err.message = err.description = 'Mandatory params - classid or body' +
                                    ' not found in request options.';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }
  return dfd.promise;
}

/*
options = {
  "classid": "classid", //mandatory
  "data": {
    "title": "assigned path title", //mandatory
    "scope": "string", //optional, default=global , ['global', 'users']
    "ext_assignedpathid": 'string', //optional
    "duedate": "epoch due date", //mandatory
    "startdate": "epoch start date", //optional
    "shared_progress": true, //optional, default=true
    "path_type": ‘flat’, //optional, default=flat , ['flat', 'hierarchical']
    "rules": {}, //optional
    "items": [  //mandatory
      {
        "item-code": "required_item-code",  //mandatory
        "item_type": "required_item-type",  //mandatory, ['dls-internal','external']
        "dls_product_code": "product_code" //mandatory only if item_type is 'dls-internal'
      }
    ],
    "context": {
       "bundle-code": "string",
       "space_key": "string"
     }
  }
}
*/
function createAssignedPath(options) {
  var self = this;
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.classid && options.data && options.data.title &&
      options.data.items && options.data.items.length > 0) {

      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.createAssignedPath;
      url = helpers.api.constructAPIUrl(url, { orgId: self.orgId, classId: options.classid });

      // Setup request with URL and Params
      var requestAPI = request.post(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(options.data);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function (error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    }
    else {
      err = {};
      err.message = err.description = 'Mandatory params - title or classid or items ' +
                                      'not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
  classid: 'string' //mandatory
  assignedpathid: 'string' //mandatory
  }
*/
function deleteAssignedPath(options) {
  var self = this;
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.classid && options.assignedpathid) {

      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.deleteAssignedPath;
      url = helpers.api.constructAPIUrl(url, { orgId: self.orgId, classId: options.classid, assignedPathId: options.assignedpathid });

      // Setup request with URL and Params
      var requestAPI = request.delete(url);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function (error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    }
    else {
      err = {};
      err.message = err.description = 'Mandatory params - classid or assignedpathid ' +
                                      'not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
    classid: 'string' //mandatory
    assignedpathid: 'string' //mandatory
    data: {
      title: 'string' //optional
      scope: 'string' //optional, ['global', 'users']
      startdate: 'string' //optional
      duedate: 'string' //optional
      items: [  //optional
        {
          item-code: 'string',  //mandatory
          item_type: 'string',  //mandatory, ['dls-internal','external']
          dls_product_code: 'string' //mandatory only if item_type is 'dls-internal'
        }
      ],
      "rules": {},                // Optional
      "context": {                // Optional (Needed for system event only)
        "bundle-code": "string",
        "space_key": "string"
      }
    }
  }
*/
function updateAssignedPath(options) {
  var self = this;
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.classid && options.assignedpathid) {

      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.deleteAssignedPath;
      url = helpers.api.constructAPIUrl(url, { orgId: self.orgId, classId: options.classid, assignedPathId: options.assignedpathid });

      // Setup request with URL and Params
      var requestAPI = request.put(url);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }
      if(options.data) { requestAPI.send(options.data); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function (error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    }
    else {
      err = {};
      err.message = err.description = 'Mandatory params - classid or assignedpathid ' +
                                      'not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/**
 * options={
  "title": "string", //mandatory
  "startdate": 0, //mandatory
  "enddate": 0, //mandatory
  "path": "string"
}
 */
function createGroup(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    // Validations

    if(options && options.title && options.startdate && options.enddate) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.allGroups;
      url = helpers.api.constructAPIUrl(url, { orgId: self.orgId });

      // Setup request with URL and Params
      var requestAPI = request.post(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(options);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function(error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response); }
      });
    }
    else {
      err = {};
      err.message = err.description = 'title or startdate or enddate not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/* options = {
    "path": "string" //mandatory, Path of the group(this path group will also be returned,
    "cursor": "string"
  };
*/
function getAllGroupsByPath(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.path) {

      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.allGroups;
      url = helpers.api.constructAPIUrl(url,{ orgId: self.orgId });

      var queryParams = { path: options.path };
      if(options.cursor) { queryParams.cursor = options.cursor; }

      // Setup request with URL and Params
      var requestAPI = request.get(url).query(queryParams);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function (error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response); }
      });
    }
    else {
      err = {};
      err.message = err.description = 'Mandatory params - path not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/* options = {
    "groupId": "string" //mandatory
  };
*/
function getAGroup(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.groupId) {

      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.aParticularGroup;
      url = helpers.api.constructAPIUrl(url,{ orgId: self.orgId, groupId: options.groupId });

      // Setup request with URL and Params
      var requestAPI = request.get(url);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function (error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response); }
      });
    }
    else {
      err = {};
      err.message = err.description = 'Mandatory params - groupId not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/* options = {
    "groupId": "string" //mandatory
    "body": {
      "title": "string"
      "startdate": "string",
      "enddate":"string"
    }
  };
*/
function updateGroup(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.groupId) {

      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.aParticularGroup;
      url = helpers.api.constructAPIUrl(url,{ orgId: self.orgId, groupId: options.groupId });

      // Setup request with URL and Params
      var requestAPI = request.put(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(options.body);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function (error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response); }
      });
    }
    else {
      err = {};
      err.message = err.description = 'Mandatory params - groupId not found in ' +
                                      'request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/* options = {
    "groupId": "string" //mandatory
  };
*/
function deleteGroup(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if(options && options.groupId) {

      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.aParticularGroup;
      url = helpers.api.constructAPIUrl(url,{ orgId: self.orgId, groupId: options.groupId });

      // Setup request with URL and Params
      var requestAPI = request.delete(url);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function (error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response); }
      });
    }
    else {
      err = {};
      err.message = err.description = 'Mandatory params - groupId not found in ' +
                                      'request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
    groupId: "string", //mandatory
    cursor: "cursor"
  }
*/
function getAllMembersOfAGroup(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer(), params = {};
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  // Validations
  else{
    if(options && options.groupId) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.getAllMembersOfAGroup;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId,
        groupId: options.groupId
      });

      // Setup request with URL and Param
      if(options.cursor){ params.cursor = options.cursor; };

      var requestAPI = request.get(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function(error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response); }
      });
    } else {
      err = {};
      err.message = err.description = 'Mandatory param - groupId not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
    path: "string", //mandatory
    cursor: "string"
  }
*/
function getAllGroupMembersByPath(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer(), params = {};
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  // Validations
  else {
    if(options && options.path) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.getAllGroupMembersByPath;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId
      });

      // Setup request with URL and Params
      params.path = options.path;
      if(options.cursor){ params.cursor = options.cursor; };

      var requestAPI = request.get(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .query(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function(error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response); }
      });
    } else {
      err = {};
      err.message = err.description = 'Mandatory param - path not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {

    groupId: "string", //mandatory
    body: {
      users: [
        {
          id: "string", // User’s external id - mandatory
          dls_user_id: "string", // User’s dls id - mandatory
          email: "string", //mandatory
          first_name: "string", //mandatory
          last_name: "string", //mandatory
          name: "string", //mandatory
          role: "string" //mandatory
        }
      ]
    }
  }
*/
function createMultiUserGroupMembership(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer(), params = {};
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  // Validations

  else {
    if(options && options.groupId && options.body && options.body.users && (options.body.users.length > 0)) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.userGroupMembership;
      url = helpers.api.constructAPIUrl(url, { orgId: self.orgId, groupId: options.groupId });

      // Setup request with URL and Params
      params = options.body;

      var requestAPI = request.post(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }
      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function(error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response); }
      });
    } else {
      err = {};
      err.message = err.description = 'Mandatory param - groupId or body or body.users(min. 1 user) ' +
                                      'not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
    "groupId": "string", //mandatory
    "body": {            //mandatory
      users: [           //mandatory
        {
          id: "string" // User’s external id - mandatory
        }
      ]
  }
*/
function deleteMultiUserGroupMembership(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer(), params = {};
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  // Validations
  else {
    if(options && options.groupId && options.body && options.body.users && (options.body.users.length > 0)) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.userGroupMembership;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId,
        groupId: options.groupId
      });

      // Setup request with URL and Params
      params = options.body;
      var requestAPI = request.delete(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);
      requestAPI.end(function(error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response); }
      });
    } else {
      err = {};
      err.message = err.description = 'Mandatory param - groupId or body or body.users(min. 1 user) ' +
                                      'not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/* options= {
   "groupId": "string", //mandatory
  };
*/
function archiveGroup(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if (options && options.groupId) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.archiveAParticularGroup;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId,
        groupId: options.groupId
      });

      // Setup request with URL and Params
      var requestAPI = request.put(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send({});
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function (error, response) {
        if (error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        } else {
          dfd.resolve(response.body);
        }
      });
    }
    else {
      err = {};
      err.message = err.description = 'Mandatory param - groupId not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/* options= {
   "groupId": "string", //mandatory
  };
*/
function unarchiveGroup(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  else {
    if (options && options.groupId) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.unarchiveAParticularGroup;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId,
        groupId: options.groupId
      });

      // Setup request with URL and Params
      var requestAPI = request.put(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send({});
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function (error, response) {
        if (error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        } else {
          dfd.resolve(response.body);
        }
      });
    }
    else {
      err = {};
      err.message = err.description = 'Mandatory param - groupId not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
    userId: "string", //mandatory
    path: "string", //mandatory
    cursor: "string", // optional
  }
*/
function getMyAllMemberships(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer(), params = {};
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  // Validations
  else {
    if(options && options.userId && options.path) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.getMyAllMemberships;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId,
        userId: options.userId
      });

      // Setup request with URL and Params
      params.path = options.path;
      if(options.cursor){ params.cursor = options.cursor; };

      var requestAPI = request.get(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .query(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.end(function(error, response) {
        if(error) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response); }
      });
    } else {
      err = {};
      err.message = err.description = 'Mandatory param - userId or path not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
    classId: "string", //mandatory
    body : {
      items :         //mandatory, Min: 1, Max: 200
      [{
        "productcode": "string",
        "item-code": "string",
        "link-statementid": "string",
        "groupid": "string",
        “type”: “dls-internal”, //mandatory
        "data": { ... }
       }]
    }
  }
*/
function addItemsToShowcaseOfAClass(options){
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  // Validations
  else {
    if(options && options.classId && options.body) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.showcaseItems;
      url = helpers.api.constructAPIUrl(url, { orgId: self.orgId, classId: options.classId });

      // Setup request with URL and Params
      var requestAPI = request.post(url);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }
      requestAPI.send(options.body);

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      // Call Add items to showcase API
      requestAPI.end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    } else {
      err = {};
      err.message = err.description = 'Mandatory param - classId or body not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
    classId: "string", //mandatory
    body : {
      items : [ "id1", "id2", "id3", ... ] //mandatory
    }
  }
*/
function deleteItemsFromShowcaseOfAClass(options){
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) { dfd.reject(err); }
  // Validations
  else {
    if(options && options.classId && options.body) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
                self.config.AUTH_API_URLS.showcaseItems;
      url = helpers.api.constructAPIUrl(url, { orgId: self.orgId, classId: options.classId });

      // Setup request with URL and Params
      var requestAPI = request.delete(url);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }
      requestAPI.send(options.body);

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      // Call delete items from showcase API
      requestAPI.end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
    } else {
      err = {};
      err.message = err.description = 'Mandatory param - classId or body not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/**
 * options = {
 * classid: 'class id of the class',
 * title: 'title of clone class',
 * startdate: 'Epoch(Unix) timestamp in milliseconds',
 * enddate: 'Epoch(Unix) timestamp in milliseconds',
 * instructor: 'user who clones the class',
 * clone_setting: {                                     // optional field
 *  "students": true,
 *  "teachers": true,
 *  "products": true,
 *  "bundles": true,
 *  "groups": true,
 *  "assigned_paths": true,
 *  "skip_assigned_path_create_notification": true,
 *  "tags": true,
 *  "analyticsharingmodel": true,
 *  "analytics_score_aggregation_type": true,
 *  "ext_data": true,
 *  "limits": true,
 *  "advanced": {
 *  "students": [
 *      {
 *        "ext_user_id": "string"
 *      }
 *    ],
 *    "teachers": [
 *      {
 *        "ext_user_id": "string"
 *      }
 *    ],
 *    "groups": [
 *      {
 *        "groupid": "string"
 *      }
 *    ],
 *    "assigned_paths": [
 *      {
 *        "assigned_path_id": "string",
 *        "startdate": 0,
 *        "duedate": 0
 *      }
 *    ],
 *    "products": [
 *      {
 *        "productcode": "string"
 *      }
 *    ],
 *    "bundles": [
 *      {
 *        "bundlecode": "string"
 *      }
 *    ],
 *    "analyticsharingmodel": "NOINHERIT_SYNCBACK",
 *    "analytics_score_aggregation_type": "best",
 *    "limits": {
 *      "los": 0,
 *      "students": 0
 *    }
 *  }
 * },
 * }
 */
function cloneClass(options) {
  var self = this;

  //Initializing promise
  var dfd = q.defer();

  //Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) {
    dfd.reject(err);
  } else {
    if(options && options.title && options.startdate && options.enddate
      && options.instructor && options.classid) {
      //Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.cloneClass;
      url = helpers.api.constructAPIUrl(url,  { orgId: self.orgId, classId: options.classid });

      //Setup request with URL and Params
      var requestAPI = request.post(url).send(options);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
      .agent(keepaliveAgent)
      .end(function(err, response) {
        if(err) {
          err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
          dfd.reject(err);
        } else {
          dfd.resolve(response.body);
        }
      });
    } else {
      err = {};
      err.message = err.description = 'title or startdate or enddate or instructor or classid not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
    classid: "string", //mandatory
    body : {
      gradebook_id: "string", //mandatory
      title: "string",  //mandatory
      data: {}
    }
  }
*/
function createGradebookMeta(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();

  //Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(error) {
      dfd.reject(error);
  } else {
    if(options && options.classid && options.body) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.createOrGetGradebookMeta;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classid
      });

      var requestAPI = request.post(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(options.body);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if(error) {
            var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            dfd.reject(err);
          }
          else { dfd.resolve(response.body); }
      });
    } else {
      var err = {};
      err.message = err.description = 'Mandatory param - classid or body' +
                                      ' not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }

  return dfd.promise;
}

/*
  options = {
    classid: "string", //mandatory
    gradebook_id: "string", //mandatory
    body : {    //mandatory
      title: "string",
      data: {}
    }
  }
*/
function updateGradebookMeta(options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;
  var error = {};

  //Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) {
    deferred.reject(err);
  } else {
    if (options && options.classid && options.gradebook_id && options.body) {
      if (Object.keys(options.body).length !== 0) {
        // Passed all validations, Contruct API url
        var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.updateOrDeleteGradebookMeta;

        url = helpers.api.constructAPIUrl(url, {
          orgId: self.orgId, classId: options.classid, gradebook_id: options.gradebook_id
        });

        var params = options.body;
        // Setup request with URL and Params
        var requestAPI = request.put(url)
          .set('Content-Type', 'application/json')
          .set('Accept', 'application/json')
          .send(params);

        if (self.traceid) {
          requestAPI.set('X-Amzn-Trace-Id', self.traceid);
        }

        //Setup token in Authorization header
        requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

        requestAPI
          .agent(keepaliveAgent)
          .end(function(error, response) {
            if (error) {
              error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
              deferred.reject(error);
            } else {
              deferred.resolve(response.body);
            }
          });
      } else {
        error.message = error.description = 'Body of the request cannot be empty.';
        error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
        deferred.reject(error);
      }
    } else {
      error.message = error.description = 'Mandatory params: classid, gradebook_id or body' +
        ' not found in the request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }

  return deferred.promise;
}

/*
  options = {
    classid: "string", //mandatory
    gradebook_id: "string" //mandatory
  }
*/
function deleteGradebookMeta(options) {
  var self = this;
  var dfd = q.defer();

  //Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(error) {
      dfd.reject(error);
  } else {
    if(options && options.classid && options.gradebook_id) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.updateOrDeleteGradebookMeta;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classid, gradebook_id: options.gradebook_id
      });

      // Setup request with URL and Params
      var requestAPI = request.delete(url);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function (error, response) {
          if(error) {
            var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            dfd.reject(err);
          }
          else { dfd.resolve(response.body); }
      });
    }
    else {
      var err = {};
      err.message = err.description = 'Mandatory params - classid or gradebook_id' +
                                      ' not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }

  return dfd.promise;
}

/*
  options = {
    classid: "string", //mandatory
    gradebook_id: "string" //mandatory
  }
*/
function getParticularGradebookMetaOfAClass(options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;

  //Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) {
    deferred.reject(err);
  } else {
    if (options && options.classid && options.gradebook_id) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
        self.config.AUTH_API_URLS.createOrGetGradebookMeta;

      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classid
      });

      // Setup request with URL and Params
      var params = {gradebook_id: options.gradebook_id};
      var requestAPI = request.get(url).query(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if (error) {
            error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            deferred.reject(error);
          } else {
            if (response.body.entities) {
              deferred.resolve(response.body.entities[0]);
            } else {
              /**
               * An empty response is sent when the requested gradebook doesn't exist in the class.
               * In this case, the API sends an 204 (No-Content) response.
               */
              deferred.resolve();
            }
          }
      });
    } else {
      var error = {};
      error.message = error.description = 'Mandatory params: classid or gradebook_id' +
        ' not found in request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }

  return deferred.promise;
}

/*
  options = {
    classid: "string", //mandatory
    cursor: "string"
  }
*/
function getAllGradebooksMetaOfAClass (options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;

  //Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) {
    deferred.reject(err);
  } else {
    if (options && options.classid) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.createOrGetGradebookMeta;

      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classid
      });

      // Setup request with URL and Params
      var params = {};
      if(options.cursor){ params.cursor = options.cursor; }

      var requestAPI = request.get(url).query(params);

      if (self.traceid) {
        requestAPI.set('X-Amzn-Trace-Id', self.traceid);
      }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if (error) {
            error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            deferred.reject(error);
          } else {
            deferred.resolve(response.body);
          }
        });
    } else {
      var error = {};
      error.message = error.description = 'Mandatory params: classid not found in request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }
  return deferred.promise;
}

/*
  options = {
    classid: "string", //mandatory
    gradebook_id: "string", //mandatory
    body : {
      "columns": [
        {
          "column_id": "string",     // Mandatory
          "title": "string",
          "type": "product / custom",
          "weightage": "string",
          "bundle-codes": [],
          "productcode": "string",
          "custom_component_code": "string",
          "scoring_type": "string",
          "items": [
            {
              "item-code": "string"
            }
          ],
          "data": {...}
        }
      ]
    }
  }
*/
function addGradebookColumns(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();

  //Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(error) {
      dfd.reject(error);
  } else {
    if(options && options.classid && options.gradebook_id && options.body) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.gradebookColumns;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classid, gradebook_id: options.gradebook_id
      });

      var requestAPI = request.post(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(options.body);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if(error) {
            var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            dfd.reject(err);
          }
          else { dfd.resolve(response.body); }
      });
    } else {
      var err = {};
      err.message = err.description = 'Mandatory param - classid, gradebook_id or body' +
                                      ' not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
    classid: "string", //mandatory
    gradebook_id: "string", //mandatory
    body : {
      "columns": [
        {
          "title": "string",
          "weightage": "string",
          "items": [
            {
              "item-code": "string"
            }
          ],
          "data": {...}
        },
        {...}
      ]
    }
  }
*/
function updateMultipleGradebookColumns(options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;
  var error = {};

  //Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) {
    deferred.reject(err);
  } else {
    if (options && options.classid && options.gradebook_id && options.body && options.body.columns) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.gradebookColumns;

      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId,
        classId: options.classid,
        gradebook_id: options.gradebook_id
      });

      var params = options.body;
      // Setup request with URL and Params
      var requestAPI = request.put(url)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .send(params);

      if (self.traceid) {
        requestAPI.set('X-Amzn-Trace-Id', self.traceid);
      }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if (error) {
            error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            deferred.reject(error);
          } else {
            deferred.resolve(response.body);
          }
        });
    } else {
      error.message = error.description = 'Mandatory params: classid, gradebook_id, body or body.columns' +
        ' not found in the request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }
  return deferred.promise;
}

/*
  options = {
    classid: "string", //mandatory
    gradebook_id: "string", //mandatory
    body : {
      "columns": [
        {
          "column_id": "string",     // Mandatory
        }
      ]
    }
  }
*/
function removeGradebookColumns(options) {
  var self = this;
  var dfd = q.defer();

  //Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(error) {
      dfd.reject(error);
  } else {
    if(options && options.classid && options.gradebook_id && options.body) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.gradebookColumns;
      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classid, gradebook_id: options.gradebook_id
      });

      // Setup request with URL and Params
      var requestAPI = request.delete(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(options.body);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function (error, response) {
          if(error) {
            var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            dfd.reject(err);
          }
          else { dfd.resolve(response.body); }
      });
    }
    else {
      var err = {};
      err.message = err.description = 'Mandatory params - classid, gradebook_id or body' +
                                      ' not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
    classid: "string", //mandatory
    gradebook_id: "string", //mandatory
    column_id: "string"   //mandatory
  }
*/
function getParticularColumnOfAGradebook (options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;

  //Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) {
    deferred.reject(err);
  } else {
    if (options && options.classid && options.gradebook_id && options.column_id) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
        self.config.AUTH_API_URLS.gradebookColumns ;

      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classid, gradebook_id: options.gradebook_id
      });

      // Setup request with URL and Params
      var params = {column_id: options.column_id};
      var requestAPI = request.get(url).query(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if (error) {
            error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            deferred.reject(error);
          } else {
            deferred.resolve(response.body.entities[0]);
          }
      });
    } else {
      var error = {};
      error.message = error.description = 'Mandatory params: classid, gradebook_id or column_id' +
        ' not found in request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }
  return deferred.promise;
}

/*
  options = {
    classid: "string", //mandatory
    gradebook_id: "string", //mandatory
    cursor: "string"   //optional
  }
*/
function getAllColumnsOfAGradebook (options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;

  //Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) {
    deferred.reject(err);
  } else {
    if (options && options.classid && options.gradebook_id) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH +
        self.config.AUTH_API_URLS.gradebookColumns ;

      url = helpers.api.constructAPIUrl(url, {
        orgId: self.orgId, classId: options.classid, gradebook_id: options.gradebook_id
      });

      // Setup request with URL and Params
      var params = {};
      if(options.cursor){ params.cursor = options.cursor; }

      var requestAPI = request.get(url).query(params);

      if (self.traceid) {
        requestAPI.set('X-Amzn-Trace-Id', self.traceid);
      }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if (error) {
            error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            deferred.reject(error);
          } else {
            deferred.resolve(response.body);
          }
        });
    } else {
      var error = {};
      error.message = error.description = 'Mandatory params: classid or gradebook_id' +
        ' not found in request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }
  return deferred.promise;
}

/*
  options = {
    component_code: "string", //mandatory
    cursor: "string"   //optional
  }
*/
function getAllClassesOfAComponent (options) {
    // Initializing promise
    var deferred = q.defer();
    var self = this;
    var error = {};

    //Validations
    var err = helpers.validations.isAuthenticated(self.orgId, self.token);
    if(err) {
      deferred.reject(err);
    } else {
      if (options && options.component_code) {
        // Passed all validations, Contruct API url
        var url = self.config.DEFAULT_HOSTS.AUTH +
          self.config.AUTH_API_URLS.getAllClassesOfAComponent;

        url = helpers.api.constructAPIUrl(url, {
          orgId: self.orgId,
          component_code: options.component_code
        });

        var params = {};
        if(options.cursor){ params.cursor = options.cursor; }

        var requestAPI = request.get(url).query(params);

        if (self.traceid) {
          requestAPI.set('X-Amzn-Trace-Id', self.traceid);
        }

        //Setup token in Authorization header
        requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

        requestAPI
          .agent(keepaliveAgent)
          .end(function(error, response) {
            if (error) {
              error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
              deferred.reject(error);
            } else {
              deferred.resolve(response.body);
            }
          });
      } else {
        error.message = error.description = 'Mandatory params: component_code' +
          ' not found in the request options.';
        error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
        deferred.reject(error);
      }
    }
    return deferred.promise;
}

/*
  options = {
    component_code: "string" //mandatory
  }
*/
function removeAllGradebookColumnsOfCustomComponent (options) {
    // Initializing promise
    var deferred = q.defer();
    var self = this;
    var error = {};

    //Validations
    var err = helpers.validations.isAuthenticated(self.orgId, self.token);
    if(err) {
      deferred.reject(err);
    } else {
      if (options && options.component_code) {
        // Passed all validations, Contruct API url
        var url = self.config.DEFAULT_HOSTS.AUTH +
          self.config.AUTH_API_URLS.removeAllGradebookColumnsOfCustomComponent;

        url = helpers.api.constructAPIUrl(url, {
          orgId: self.orgId,
          component_code: options.component_code
        });

        // Setup request with URL and Params
        var requestAPI = request
          .delete(url)
          .set('Content-Type', 'application/json')
          .set('Accept', 'application/json')
          .send(options.body);

        if (self.traceid) {
          requestAPI.set('X-Amzn-Trace-Id', self.traceid);
        }

        //Setup token in Authorization header
        requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

        requestAPI
          .agent(keepaliveAgent)
          .end(function(error, response) {
            if (error) {
              error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
              deferred.reject(error);
            } else {
              deferred.resolve(response.body);
            }
          });
      } else {
        error.message = error.description = 'Mandatory params: component_code' +
          ' not found in the request options.';
        error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
        deferred.reject(error);
      }
    }
    return deferred.promise;
}

/*
  options = {
    body : {
      custom_component_code: "string",  // Mandatory
      title: "string",                  // Mandatory
      custom_component_type: "string",  // Mandatory
      scoring_type: "string",
      items: [{...}],
      data: {...}
    }
  }
*/
function createCustomComponent(options) {
  var self = this;

  // Initializing promise
  var deferred = q.defer();

  // Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (error) {
      deferred.reject(error);
  } else {
    if (options && options.body) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.customComponents;
      url = helpers.api.constructAPIUrl(url, { orgid: self.orgId });

      var requestAPI = request.post(url)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .send(options.body);
      if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if (error) {
            var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            deferred.reject(err);
          } else {
            deferred.resolve(response.body);
          }
      });
    } else {
      var err = {};
      err.message = err.description = 'Mandatory param - \'body\' not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      deferred.reject(err);
    }
  }

  return deferred.promise;
}

/*
  options = {
    custom_component_code: "string",    // Mandatory
    body : {
      title: "string",
      custom_component_type: "string",
      items: [{...}],
      data: {...}
    }
  }
*/
function updateCustomComponent(options) {
  var self = this;

  // Initializing promise
  var deferred = q.defer();

  // Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (error) {
    deferred.reject(error);
  } else {
    if (options && options.custom_component_code && options.body) {
      if (Object.keys(options.body).length === 0) {
        error.message = error.description = 'Mandatory params: \'custom_component_code\' or \'body\' not found in the request options.';
        error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
        deferred.reject(error);
      } else {
        // Passed all validations, Contruct API url
        var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.particularCustomComponent;
        url = helpers.api.constructAPIUrl(url, {
          orgid: self.orgId, custom_component_code: options.custom_component_code
        });

        // Setup request with URL and Params
        var params = options.body;
        var requestAPI = request.put(url)
          .set('Content-Type', 'application/json')
          .set('Accept', 'application/json')
          .send(params);
        if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

        // Setup token in Authorization header
        requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

        requestAPI
          .agent(keepaliveAgent)
          .end(function(error, response) {
            if (error) {
              error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
              deferred.reject(error);
            } else {
              deferred.resolve(response.body);
            }
          });
      }
    } else {
      error = {};
      error.message = error.description = 'Mandatory params: \'custom_component_code\' or \'body\' not found in the request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }

  return deferred.promise;
}

/*
  options = {
    custom_component_code: "string", // Mandatory
  }
*/
function deleteCustomComponent(options) {
  var self = this;

  // Initializing promise
  var deferred = q.defer();

  // Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (error) {
      deferred.reject(error);
  } else {
    if (options && options.custom_component_code) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.particularCustomComponent;
      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId, custom_component_code: options.custom_component_code
      });

      // Setup request with URL and Params
      var requestAPI = request.delete(url);
      if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function (error, response) {
          if (error) {
            var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            deferred.reject(err);
          } else {
            deferred.resolve(response.body);
          }
      });
    } else {
      var err = {};
      err.message = err.description = 'Mandatory params - \'custom_component_code\' not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      deferred.reject(err);
    }
  }

  return deferred.promise;
}

/*
  options = {
    custom_component_code: "string", // Mandatory
  }
*/
function getParticularCustomComponent(options) {
  var self = this;

  // Initializing promise
  var deferred = q.defer();

  // Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (err) {
    deferred.reject(err);
  } else {
    if (options && options.custom_component_code) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.particularCustomComponent;

      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId, custom_component_code: options.custom_component_code
      });

      // Setup request with URL and Params
      var requestAPI = request.get(url);
      if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if (error) {
            error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            deferred.reject(error);
          } else {
            deferred.resolve(response.body);
          }
      });
    } else {
      var error = {};
      error.message = error.description = 'Mandatory params: \'custom_component_code\' not found in request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }

  return deferred.promise;
}

/*
  options = {
    cursor: "string"
  }
*/
function getAllCustomComponents(options) {
  var self = this;

  // Initializing promise
  var deferred = q.defer();

  // Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (error) {
    deferred.reject(error);
  } else {
    // Passed all validations, Contruct API url
    var url = self.config.DEFAULT_HOSTS.AUTH + self.config.AUTH_API_URLS.customComponents;
    url = helpers.api.constructAPIUrl(url, { orgid: self.orgId });

    // Setup request with URL and Params
    var params = {};
    if (options && options.cursor) { params.cursor = options.cursor; }

    var requestAPI = request.get(url).query(params);
    if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    // Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

    requestAPI
      .agent(keepaliveAgent)
      .end(function(error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body);
        }
      });
  }

  return deferred.promise;
}
